import { jsx as _jsx } from "react/jsx-runtime";
// Vendored from shadcn — see ./index.ts for provenance and our divergences.
import * as React from "react";
import { cva } from "class-variance-authority";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../../utils";
function BubbleGroup({ className, ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        "data-slot": "bubble-group",
        className: cn("flex min-w-0 flex-col gap-2", className),
        ...props
    });
}
const bubbleVariants = cva("group/bubble relative flex w-fit max-w-[85%] min-w-0 flex-col gap-1 group-data-[align=end]/message:self-end data-[align=end]:self-end data-[variant=ghost]:max-w-full", {
    variants: {
        variant: {
            // Brand accent for chat is `success` — the green tint of the user pill,
            // the same tint in both themes.
            accent: "*:data-[slot=bubble-content]:bg-success/10 *:data-[slot=bubble-content]:text-foreground [&>[data-slot=bubble-content]:is(button,a):hover]:bg-success/20",
            muted: "*:data-[slot=bubble-content]:bg-muted *:data-[slot=bubble-content]:text-foreground [&>[data-slot=bubble-content]:is(button,a):hover]:bg-accent",
            // `overflow-visible` undoes the content clipping the framed variants
            // need for their rounded corners. Ghost has no frame to clip to, and it
            // is the variant that carries wide tables, charts and diagrams — those
            // bring their own scroll containers and must not be cut off by the shell.
            //
            // `w-full` replaces the shrink-to-fit sizing of the framed variants, on
            // both the shell and its content. A framed bubble hugs its text; ghost
            // content is measured in the other direction — a chart or a diagram
            // sizes itself to the width it is GIVEN and contributes nothing to a
            // `fit-content` box, so under `w-fit` it would collapse to the width of
            // whatever plain text happens to sit beside it.
            ghost: "w-full border-none *:data-[slot=bubble-content]:w-full *:data-[slot=bubble-content]:overflow-visible *:data-[slot=bubble-content]:rounded-none *:data-[slot=bubble-content]:bg-transparent *:data-[slot=bubble-content]:p-0"
        }
    },
    defaultVariants: {
        variant: "accent"
    }
});
function Bubble({ variant = "accent", align = "start", className, ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        "data-slot": "bubble",
        "data-variant": variant,
        "data-align": align,
        className: cn(bubbleVariants({
            variant
        }), className),
        ...props
    });
}
function BubbleContent({ asChild = false, className, ...props }) {
    const Comp = asChild ? Slot : "div";
    return /*#__PURE__*/ _jsx(Comp, {
        "data-slot": "bubble-content",
        className: cn("w-fit max-w-full min-w-0 overflow-hidden rounded-2xl border border-transparent px-4 py-3 text-sm leading-relaxed wrap-break-word group-data-[align=end]/bubble:self-end [button]:text-left [button,a]:transition-colors [button,a]:outline-none [button,a]:focus-visible:border-ring [button,a]:focus-visible:ring-2 [button,a]:focus-visible:ring-ring/50", className),
        ...props
    });
}
export { BubbleGroup, Bubble, BubbleContent, bubbleVariants };

//# sourceMappingURL=bubble.js.map